import { render, staticRenderFns } from "./balancing-approval-reject-confirmation.vue?vue&type=template&id=83a22a7a&scoped=true&"
import script from "./balancing-approval-reject-confirmation.vue?vue&type=script&lang=js&"
export * from "./balancing-approval-reject-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./balancing-approval-reject-confirmation.vue?vue&type=style&index=0&id=83a22a7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a22a7a",
  null
  
)

export default component.exports